import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const mutationFn = ({ addressIds, stageId }) => {
  return request.post(
    'FlatsGrid/check_stage_address_life_cycle',
    { addressIds, stageId },
    undefined,
    'Error',
    undefined,
    undefined,
    true
  );
};

export const useCheckRoomListStage = (options) => {
  return useMutation(mutationFn, options);
};
